// extracted by mini-css-extract-plugin
export default {"new-stories-btn":"styles-module__new-stories-btn___vSMmi","text":"styles-module__text___ihkv1"};